const state = {
    task: null,
    lead: null,
    patientCanban: null,
    siteForm: null,
    showCallModal: false,
    wazzupIframeUrl: '',
    wazzupEnabled: false,
    funnelApplicationsCache: null,
    newPanelAuraNotifications: 0,
    newPanelGreenApiNotifications: 0,
    newPanelJetApiNotifications: 0,
}

const getters = {

}

const mutations = {
    setTask(state, value) {
        state.task = value
    },
    setLead(state, value) {
        state.lead = value
    },
    setPatientCanban(state, value) {
        state.patientCanban = value
    },
    setSiteForm(state, value) {
        state.siteForm = value
    },
    setShowCallModal(state, value) {
        state.showCallModal = value
    },
    setWazzupIframeUrl(state, value) {
        state.wazzupIframeUrl = value
    },
    setWazzupEnabled(state, value) {
        state.wazzupEnabled = value
    },
    setFunnelApplicationsCache(state, value) {
        state.funnelApplicationsCache = value
    },
    clearPanelNotifications(state) {
        state.newPanelAuraNotifications = 0
        state.newPanelGreenApiNotifications = 0
        state.newPanelJetApiNotifications = 0
    }
}

const actions = {

}

export default {
    state,
    actions,
    mutations,
    getters
}
